import type {UITask} from '../../types/task'
import {getTaskTitle} from '../../utils/task-helpers'
import {WithShimmerEffect} from '@github-ui/copilot-chat-visuals/WithShimmerEffect'
import {ListItemTitle} from './ListParts'
import styles from './TaskListItem.module.css'

export interface TaskTitleProps {
  task: UITask
  /** Display text. Default: getTaskTitle(task, task.pull?.title) */
  title?: string
  /** Optional prefix prepended to title (e.g. "Review of") */
  prefix?: string
  /** Link URL. Omit for non-linked (optimistic) state */
  href?: string
  onClick?: (e: React.MouseEvent) => void
  /** Show shimmer effect for optimistic tasks */
  shimmer?: boolean
}

export function TaskTitle({task, title, prefix, href, onClick, shimmer}: TaskTitleProps) {
  const displayTitle = title ?? getTaskTitle(task, task.pull?.title)
  const text = prefix ? `${prefix} ${displayTitle}` : displayTitle

  if (shimmer) {
    return (
      <WithShimmerEffect className={styles.shimmeringTitle} innerClassName="d-flex">
        <ListItemTitle as="div">{text}</ListItemTitle>
      </WithShimmerEffect>
    )
  }

  return (
    <ListItemTitle onClick={onClick} as="a" href={href}>
      {text}
    </ListItemTitle>
  )
}
